import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import InputIcon from '@mui/icons-material/Input';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import BoolSetting from "../../../../../../../components/global/Settings/BoolSetting";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";
import { useGetEnumsQuery, useGetSettingsQuery } from "../../../../../../../newapi/global/generalApiSlice";


const Inbound = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { data: settings} = useGetSettingsQuery("inbound");
  const { data: stockSettings} = useGetSettingsQuery("stock");
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  const { data: globalEnums, enumIsLoading } = useGetEnumsQuery();

  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);

  return props.isActive ? (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 4,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            // background:"purple",
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_inbound_heading")}</Subheading>
            <Text light>{t("core_inbound_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>
        {/* <GridActions></GridActions> */}
        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
              // display:"none"
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
        <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              padding: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
              "@media screen and (max-width: 47.9375em)": {
                  gap:2,
              },
            }}
          >
            {/* <DropdownSetting 
            settings={settings} 
            objects={globalEnums ? globalEnums["inboundline.process.type"].map((item, index) => ({ id: item, value: item, name: t(item) })) : []} 
            noselection={"choose_type"}
            variant={"default"} 
            skey="inbound_process_type"
            /> */}
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_dimension_and_weight_required"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_carrier_required"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_lot_required"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_batch_required"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_has_repacking"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_concept_enabled"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} subtitle={false} variant={1} skey="inbound_autostore_picking_location"/>
            <BoolSetting manualSave onChange={handleChange} settings={stockSettings} subtitle={false} variant={1} skey="stock_allow_multibatch_locations"/>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default Inbound;
